import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";
import apiReminderBuilder from "../../../api";

// Advanced filter of the Domain Event list. Every key must also be in FILTER_FIELDS of the backend's
// reminder_setup/domain_event/controller.js, the whitelist get-all filters on.
export const domainEventFilterFields = [
  { key: "source_fid", label: "Source", type: "select", group: "Details", optionsKey: "sources", optionLabel: "label", optionValue: "id" },
  { ...STATUS_FIELD, group: "Details" },
  { key: "created_date", label: "Created", type: "datetime", group: "Dates" },
];

export const loadDomainEventFilterDependencies = async () => {
  const [sourcesRes] = await Promise.allSettled([apiReminderBuilder.getSourceOptions()]);
  return { sources: sourcesRes.status === "fulfilled" ? sourcesRes.value?.data?.data || [] : [] };
};
